import 'core-js/fn/symbol';
import 'core-js/fn/object/assign';
import 'core-js/fn/promise';
import 'core-js/fn/array/includes';
import 'core-js/fn/array/find';



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/compatibility.js